import { useMemo } from 'react';

import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { convertResponseToOptions } from '../../../utils/utils';

import { getFunctionGroupOptions } from 'RestAPIs/admin';

import { ControlledAutoComplete, showSnackbar } from 'components/shared';

type Props = {
  control: Control<any>;
  disabled?: boolean;
};

export default function FunctionGroupSelect({ control, disabled }: Props) {
  const { t } = useTranslation();

  const { data } = useQuery({
    queryKey: ['functionGroupOpts'],
    queryFn: async () => {
      const { data } = await getFunctionGroupOptions();
      return data;
    },
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('fetchError')
      });
    }
  });

  const options = useMemo(() => convertResponseToOptions(data), [data]);

  return (
    <ControlledAutoComplete
      name="parentFunction"
      options={options}
      control={control}
      variant="outlined"
      label={t('functions.fields.parentFunctionId')}
      disabled={disabled}
      disableClearable={false}
      idProperty="value"
      sortByProp="label"
      optionLabelProp="label"
      fullWidth
    />
  );
}
